import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { DeviceType } from '../../interfaces/api/deviceType';
import { fetchDeviceTypes } from '../services/deviceTypes.service';
import { DeviceTypeFilterParams } from '../../api/deviceTypes';

interface DeviceTypeState {
	deviceTypes: {
		[id: number]: DeviceType;
	};
	isLoading: boolean;
}

const initialState = {
	deviceTypes: [],
	isLoading: false,
} as DeviceTypeState;

export const fetchDeviceTypesThunk = createAsyncThunk<
	DeviceType[],
	{ params: DeviceTypeFilterParams }
>('deviceType/fetchDeviceTypes', async ({ params }, { rejectWithValue }) => {
	try {
		return await fetchDeviceTypes(params);
	} catch (error) {
		return rejectWithValue(error);
	}
});

const deviceTypeSlice = createSlice({
	name: 'deviceType',
	initialState,
	reducers: {
		resetDeviceType: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchDeviceTypesThunk.fulfilled, (state, action) => {
			const ret: { [id: number]: DeviceType } = {};
			state.deviceTypes = action.payload.reduce((obj, deviceType) => {
				obj[deviceType.id] = deviceType;
				return obj;
			}, ret);
			state.isLoading = false;
		});
		builder.addCase(fetchDeviceTypesThunk.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchDeviceTypesThunk.rejected, (state, action) => {
			state.deviceTypes = [];
			state.isLoading = false;
		});
	},
});

export const { resetDeviceType } = deviceTypeSlice.actions;

export default deviceTypeSlice;
